import { isAfter, isBefore, subYears } from 'date-fns'
import { Timestamp } from 'firebase/firestore'
import * as z from 'zod'

import { parseZipCode } from './zipCode'

export const timestampSchema = z.instanceof(Timestamp, {
  error: 'Please select a date',
})

export const birthdaySchema = z
  .instanceof(Timestamp, { error: 'Date of birth is required' })
  .refine(
    ts => isAfter(ts.toDate(), subYears(new Date(), 200)),
    'Date of birth is too far in the past'
  )
  .refine(
    ts => isBefore(ts.toDate(), subYears(new Date(), 18)),
    'You must be at least 18 years old'
  )

export const zipCodeSchema = z
  .string()
  .regex(/^\d{5}(-\d{4})?$/, 'Enter a 5-digit or 9-digit ZIP code')
  .refine(
    value => !!parseZipCode(value),
    'ZIP code not found. Check and try again.'
  )
